import { View } from "react-native";
import React, { useEffect, useState } from "react";
import MyView from "../../components/custom/MyView";
import {
  gray,
  kalbasiMaybe,
  lightBlue,
  lighterBlue,
  primary,
  success,
  white,
} from "../../colors";
import MyText from "../../components/custom/MyText";
import { RefreshControl, ScrollView } from "react-native-gesture-handler";
import translate from "../../functions/translate";
import { useDispatch, useSelector } from "react-redux";
import {
  changeHeaderColor,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useIsFocused, useNavigation } from "@react-navigation/native";

import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import { refresh } from "../../redux/main/mainAction";
import getListOfDoctors from "../../api/consultation/getListOfDoctors";
import PatientTestCard from "../../components/test/PatientTestCard";
import getDoctorConsultationsOld from "../../api/consultation/getDoctorConsultationsOld";

export default function Tests({ route }) {
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const navigation = useNavigation();
  const [consultations, setConsultations] = useState([]);

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor(lighterBlue));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);

  useEffect(() => {
    getDoctorConsultationsOld().then(({ data }) => {
      if (data.status === 200) setConsultations(data.data);
    });
  }, [main.refresh]);

  return (
    <KeyboardAwareScrollView
      enableOnAndroid
      extraHeight={100}
      refreshControl={
        <RefreshControl
          refreshing={false}
          onRefresh={() => {
            dispatch(refresh());
          }}
        />
      }
    >
      <View style={{ alignItems: "center" }}>
        <View style={{ flexDirection: "row" }}>
          <View style={{ flex: 5 }}>
            <View
              title={translate("specialties")}
              textColor={white}
              backgroundColor={kalbasiMaybe}
              style={{
                padding: 10,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <View style={{ marginTop: 5, alignItems: "center" }}>
                <MyText>{translate("patient list")}</MyText>
              </View>
            </View>
          </View>
        </View>
        <View style={{ marginTop: 10, width: "94%" }}>
          {consultations.length <= 0 && (
            <View
              style={{ width: "100%", alignItems: "center", marginTop: 20 }}
            >
              <MyText style={{ fontSize: 20, color: gray }}>
                {translate("there is no item")}
              </MyText>
            </View>
          )}
          {consultations.map((consultation, index) => (
            <PatientTestCard
              key={index}
              name={consultation.name}
              lastName={consultation.lastName}
              unreadCount={consultation.countNotRead}
              image={consultation.picURL}
              id={consultation.counselingId}
              childId={consultation.id}
            />
          ))}
        </View>
      </View>
      <View style={{ height: 100 }}></View>
    </KeyboardAwareScrollView>
  );
}
